import { render, staticRenderFns } from "./InsuranceCompanyServiceInfo.vue?vue&type=template&id=06c3ddd2&scoped=true&"
import script from "./InsuranceCompanyServiceInfo.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3ddd2",
  null
  
)

export default component.exports